'use client';

import React, { lazy, Suspense } from 'react';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';
import ProtectedRoute from '@/components/admin/ProtectedRoute';

// Dynamic import for heavy ArticleForm component
const ArticleForm = lazy(() => import('@/components/admin/ArticleForm'));

// C4 (Today "Promote to draft"): the held story arrives as ?storyId=&storyTitle=. Surface it as a
// banner so the promoted story context is NOT silently dropped. Deeper ArticleForm prefill from the
// story is a follow-up (see leg LOG). Reads searchParams → must live under the Suspense boundary.
function StoryContextBanner() {
  const params = useSearchParams();
  const storyId = params.get('storyId');
  const storyTitle = params.get('storyTitle');
  if (!storyId) return null;
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 pt-6">
      <div className="rounded-lg border border-blue-200 dark:border-blue-800 bg-blue-50 dark:bg-blue-900/20 px-4 py-3 text-sm text-blue-800 dark:text-blue-200">
        Drafting from ripe story{storyTitle ? `: “${storyTitle}”` : ` ${storyId}`}.{' '}
        <Link href="/admin/stories" className="underline font-medium">View in Stories &rarr;</Link>
      </div>
    </div>
  );
}

export default function NewArticlePage() {
  return (
    <ProtectedRoute>
      <div className="bg-white dark:bg-neutral-900 min-h-screen">
        <Suspense fallback={
          <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
            <div className="animate-pulse space-y-6">
              <div className="h-4 bg-gray-200 dark:bg-neutral-700 rounded w-1/4"></div>
              <div className="h-10 bg-gray-200 dark:bg-neutral-700 rounded"></div>
              <div className="h-4 bg-gray-200 dark:bg-neutral-700 rounded w-1/3"></div>
              <div className="h-64 bg-gray-200 dark:bg-neutral-700 rounded"></div>
            </div>
          </div>
        }>
          <StoryContextBanner />
          <ArticleForm />
        </Suspense>
      </div>
    </ProtectedRoute>
  );
}
